import { BestFitRepository } from '@/domain/best-fit-repository';
import { StudentRepository } from '@/domain/student-repository';
import { StudyRepository } from '@/domain/study-repository';
import { IAnonymousStudentService } from '@studyportals/anonymous-student-interfaces';
import { ITokenBasedSessionService } from '@studyportals/student-interfaces';
import mitt from 'mitt';
import Tracking from './tracking';
import { IEventAggregationService } from '@studyportals/event-aggregation-service-interface';
import { ICopilotServiceApplication } from '@studyportals/copilot-service-interfaces';
import { ICurrencyConversionService, ILocalizedContentService } from '@studyportals/portal-localized-content';
import config from '../../rollbar.config'

const eventBus = mitt();

// set in dependency checker plugin
const eventAggregationService: IEventAggregationService =
	{} as IEventAggregationService;
const sessionService: ITokenBasedSessionService = {} as ITokenBasedSessionService;
const anonymousStudent: IAnonymousStudentService =
	{} as IAnonymousStudentService;

const studyRepository: StudyRepository = {} as StudyRepository;
const bestFitRepository: BestFitRepository = {} as BestFitRepository;
const studentRepository: StudentRepository = {} as StudentRepository;
const copilotServiceApplication: ICopilotServiceApplication = {} as ICopilotServiceApplication;
const bestFitTracking = new Tracking();
const rollbar = (window && window["rollbar"] && window["rollbarIgnore"])? new window["rollbar"](config): null;

const localizedContentService: ILocalizedContentService = {} as ILocalizedContentService;

const currencyConversionService:ICurrencyConversionService = {} as ICurrencyConversionService;

export default {
	eventBus,
	eventAggregationService,
	sessionService,
	anonymousStudent,
	studyRepository,
	bestFitRepository,
	studentRepository,
	bestFitTracking,
	copilotServiceApplication,
	localizedContentService,
	currencyConversionService,
	rollbar
};
